import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const updateDisputeEvidence = {
  name: "updateDisputeEvidence" as const,
  input: z.object({
    disputeId: z.coerce.bigint(),
    source: z.enum(disputeSource),
    // Legacy fields
    accessActivityLog: z.string().optional(),
    customerCommunicationFileUrl: z.string().optional(),
    invalidDisputeReason: z.string().optional(),
    uncategorizedFileUrl: z.string().optional(),
    // New lego fields
    activityLog: z.string().optional(),
    cancellationPolicyDisclosure: z.string().optional(),
    cancellationRebuttal: z.string().optional(),
    refundPolicyDisclosure: z.string().optional(),
    refundRefusalExplanation: z.string().optional(),
    productDescription: z.string().optional(),
    cancellationPolicyFileUrl: z.string().optional(),
    refundPolicyFileUrl: z.string().optional(),
    serviceDocumentationFileUrl: z.string().optional(),
    shippingDocumentationFileUrl: z.string().optional(),
    affidavitFileUrl: z.string().optional(),
    billingAgreementFileUrl: z.string().optional(),
    orderDetailsFileUrl: z.string().optional(),
    termsAcceptanceFileUrl: z.string().optional(),
    summaryFileUrl: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
